import script from "./WinnerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./WinnerComponent.vue?vue&type=script&setup=true&lang=js"

import "./WinnerComponent.vue?vue&type=style&index=0&id=d6e8a6f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\killi\\WebstormProjects\\chess_vuejs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6e8a6f4"]])

export default __exports__